module.exports = __webpack_public_path__ + "static/img/uiam-lake-sightseeing-cruise.633ca90.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/uiam-lake-sightseeing-cruise.jpg
// module id = Owa4
// module chunks = 0